import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';

function ConverterCard({ from, to }) {
  return (
    <Link 
      to={`/en/image-converter/${from.toLowerCase()}/${to.toLowerCase()}`}
      className="block p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
    >
      <div className="flex flex-col items-center space-y-4">
        <div className="flex items-center justify-between w-full md:w-[70%]">
          <span className="font-semibold">{from}</span>
          <ArrowLongRightIcon className="w-6 h-6 text-blue-500" />
          <span className="font-semibold">{to}</span>
        </div>
      </div>
    </Link>
  );
}

export default ConverterCard;
